import refundRouterList from '@/router/modules/refund.router'

const refundPathList = refundRouterList.map(item => `/live/m${item.path}`)

export const banSiteInfoWhitePathList = [
  '/live/m/order/checkorder',
  ...refundPathList,
]

export const accountWhitePathList = [
  '/live/m/agent/myAccount',
  '/live/m/agent/rechargeRecord',
  '/live/m/agent/consumeDetail',
]
